<section class="stacksBlockContainer" id="block-footer" [ngClass]="getBlockFieldsCustomPage(blockId).data?.sticky_footer == 'yes' ? 'stickyFooter' : ''">
  <!-- Website Builder Footer Preview -->
<div *ngIf="checkPreview() && builderType === 'website'" class="previewWebsite previewWebsiteMode">
    <div class="blockControlHandlers">
    <div class="editBlock blockActionBtn" (click)="showData(blockId)">
      <mat-icon>edit</mat-icon>
    </div>
  </div>
  <!-- Floating Social Icons (Website) -->
  <ng-container *ngTemplateOutlet="floatingSocialTpl; context: { socials: getBlockFields(blockId).data?.floatingSocial }"></ng-container>
    <app-footer-template
      [data]="getBlockFields(blockId).data"
      [currentYear]="currentYear">
    </app-footer-template>
</div>

  <!-- Mobile Preview -->
  <div class="previewFooter previewMobile" [ngClass]="getBlockFieldsCustomPage(blockId).data?.footerStyle" *ngIf="checkPreview() && builderType !== 'website' && !getBlockFieldsCustomPage(blockId).data?.global_footer && getBlockFieldsCustomPage(blockId).data?.global_footer !== undefined && !builderService.globals" id="{{ 'blockid' + blockId }}">
    <div class="blockControlHandlers">
      <div class="editBlock blockActionBtn" (click)="showData(blockId)">
        <mat-icon>edit</mat-icon>
      </div>
    </div>

    <!-- Floating Social Icons (Mobile - Local Footer) -->
    <ng-container *ngTemplateOutlet="floatingSocialTpl; context: { socials: getBlockFieldsCustomPage(blockId).data?.floatingSocial }"></ng-container>

    <!-- Classic Style -->
    <div class="footerWrapper footerWithColor" *ngIf="getBlockFieldsCustomPage(blockId).data?.footerStyle == 'classic'" [ngClass]="getBlockFieldsCustomPage(blockId).data?.footerMenu">
      <div
        class="navbar"
        [ngClass]="{
          navbar: getBlockFieldsCustomPage(blockId).data?.menuItems.length <= 5,
          navbarHeight: getBlockFieldsCustomPage(blockId).data?.menuItems.length > 5,
          globalColors: getBlockFieldsCustomPage(blockId).data?.colorSource !== 'customColors',
          customColors: getBlockFieldsCustomPage(blockId).data?.colorSource === 'customColors'
        }"
        [ngStyle]="{
          'background-color': getBlockFieldsCustomPage(blockId).data?.bgColor ? getBlockFieldsCustomPage(blockId).data?.bgColor : '#3064F8'
        }"
      >
        <div class="nav-item" *ngFor="let menuItem of getBlockFieldsCustomPage(blockId).data?.menuItems; let i = index" [ngStyle]="i == 0 && getBlockFieldsCustomPage(blockId).data?.colorSource == 'customColors' ? { 'border-color': menuItem.color } : {}">
          <i class="material-icons-outlined" [ngStyle]="getBlockFieldsCustomPage(blockId).data?.colorSource == 'customColors' ? { color: menuItem.color } : {}">{{ menuItem.icon }}</i>
          <p *ngIf="menuItem.menuText && menuItem.menuText !== ''" [ngStyle]="{ color: menuItem.color }">
            {{ menuItem.menuText }}
          </p>
        </div>
      </div>
    </div>
    <!-- Circle Style -->
    <div class="footerWrapper footerWithColor circleFooterWrapper" [ngClass]="getBlockFieldsCustomPage(blockId).data?.footerMenu" *ngIf="getBlockFieldsCustomPage(blockId).data?.footerStyle == 'circle'">
      <div
        class="CircleNavbar"
        [ngClass]="{
          CircleNavbar: getBlockFieldsCustomPage(blockId).data?.menuItems.length <= 4,
          CircleNavbarHeight: getBlockFieldsCustomPage(blockId).data?.menuItems.length > 4,
          globalColors: getBlockFieldsCustomPage(blockId).data?.colorSource !== 'customColors',
          customColors: getBlockFieldsCustomPage(blockId).data?.colorSource === 'customColors'
        }"
        [ngStyle]="{
          'background-color': getBlockFieldsCustomPage(blockId).data?.bgColor ? getBlockFieldsCustomPage(blockId).data?.bgColor : '#3064F8'
        }"
      >
        <div class="CircleNavItem" *ngFor="let menuItem of getBlockFieldsCustomPage(blockId).data?.menuItems; let i = index" [ngClass]="getBlockFieldsCustomPage(blockId).data?.circleMainItem == i ? 'special-icon' : ''">
          <div
            *ngIf="getBlockFieldsCustomPage(blockId).data?.circleMainItem == i"
            class="shopping-bag-wrapper"
            [ngStyle]="{
              'background-color': getBlockFieldsCustomPage(blockId).data?.colorSource === 'customColors' ? getBlockFieldsCustomPage(blockId).data?.circleMainBgColor : ''
            }"
          >
            <i class="material-icons-outlined" [ngStyle]="{ color: menuItem.color }">{{ menuItem.icon }}</i>
          </div>
          <div *ngIf="getBlockFieldsCustomPage(blockId).data?.circleMainItem !== i">
            <i class="material-icons-outlined" [ngStyle]="{ color: menuItem.color }">{{ menuItem.icon }}</i>
            <p *ngIf="menuItem.menuText && menuItem.menuText !== ''" [ngStyle]="{ color: menuItem.color }">
              {{ menuItem.menuText }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- Expand Style -->
    <div class="footerWrapper footerWithColor expandFooterWrapper" [ngClass]="getBlockFieldsCustomPage(blockId).data?.footerMenu" *ngIf="getBlockFieldsCustomPage(blockId).data?.footerStyle == 'expand'">
      <div
        class="expand-navbar"
        [ngClass]="{
          'expand-navbar': getBlockFieldsCustomPage(blockId).data?.menuItems.length <= 3,
          expandHeight: getBlockFieldsCustomPage(blockId).data?.menuItems.length > 3,
          globalColors: getBlockFieldsCustomPage(blockId).data?.colorSource !== 'customColors',
          customColors: getBlockFieldsCustomPage(blockId).data?.colorSource === 'customColors'
        }"
        [ngStyle]="{
          'background-color': getBlockFieldsCustomPage(blockId).data?.bgColor ? getBlockFieldsCustomPage(blockId).data?.bgColor : '#3064F8'
        }"
      >
        <div class="expand-nav-item" *ngFor="let menuItem of getBlockFieldsCustomPage(blockId).data?.menuItems">
          <i class="material-icons-outlined" [ngStyle]="{ color: menuItem.color }">{{ menuItem.icon }}</i>
          <p *ngIf="menuItem.menuText && menuItem.menuText !== ''" [ngStyle]="{ color: menuItem.color }">
            {{ menuItem.menuText }}
          </p>
        </div>
      </div>
    </div>
    <!-- <div *ngIf="getBlockFields(blockId).data?.gFooterBanners[gFooterBanner.index].status">
      <img src="../../../assets/images/admob_sample.jpeg" />
    </div> -->
    <img src="../../../assets/images/adsbanner.gif" *ngIf="blockDataService.gAdMobActiveFooter" />
  </div>

  <!-- Global Footer (Mobile) -->
  <div
    class="previewFooter previewMobile"
    [ngClass]="getBlockFieldsCustomPage(blockId).data?.footerStyle == 'expand' ? 'expandPreviewFooter' : ''"
    *ngIf="checkPreview() && builderType !== 'website' && (getBlockFieldsCustomPage(blockId).data?.global_footer || getBlockFieldsCustomPage(blockId).data?.global_footer == undefined || builderService.globals)"
    id="{{ 'blockid' + blockId }}"
  >
    <div class="blockControlHandlers">
      <div class="editBlock blockActionBtn" (click)="showData(blockId)">
        <mat-icon>edit</mat-icon>
      </div>
    </div>

    <!-- Floating Social Icons (Mobile - Global Footer) -->
    <ng-container *ngTemplateOutlet="floatingSocialTpl; context: { socials: getBlockFields(blockId).data?.floatingSocial }"></ng-container>

    <!-- Classic -->
    <div
      *ngIf="getBlockFields(blockId) && getBlockFields(blockId).data?.footerMenu && (getBlockFields(blockId).data?.footerStyle == 'classic' || !getBlockFields(blockId).data?.footerStyle)"
      class="footerWrapper footerWithColor"
      [ngClass]="getBlockFields(blockId).data?.footerMenu"
      [ngStyle]="{ 'background-color': getBlockFields(blockId).data?.bgColor ? getBlockFields(blockId).data?.bgColor : '#3064F8' }"
    >
      <div
        class="navbar"
        [ngClass]="{
          navbar: getBlockFields(blockId).data?.menuItems?.length <= 5,
          navbarHeight: getBlockFields(blockId).data?.menuItems?.length > 5,
          globalColors: getBlockFields(blockId).data?.colorSource !== 'customColors',
          customColors: getBlockFields(blockId).data?.colorSource === 'customColors'
        }"
        [ngStyle]="{
          'background-color': getBlockFields(blockId).data?.bgColor ? getBlockFields(blockId).data?.bgColor : '#3064F8'
        }"
      >
        <div class="nav-item" *ngFor="let menuItem of getBlockFields(blockId).data?.menuItems; let i = index" [ngStyle]="i == 0 && getBlockFields(blockId).data?.colorSource == 'customColors' ? { 'border-color': menuItem.color } : {}">
          <i class="material-icons-outlined" [ngStyle]="getBlockFields(blockId).data?.colorSource == 'customColors' ? { color: menuItem.color } : {}">{{ menuItem.icon }}</i>
          <p *ngIf="menuItem.menuText && menuItem.menuText !== ''" [ngStyle]="{ color: menuItem.color }">
            {{ menuItem.menuText }}
          </p>
        </div>
      </div>
    </div>
    <div
      *ngIf="getBlockFields(blockId) && !getBlockFields(blockId).data?.footerMenu && getBlockFields(blockId).footerMenu && getBlockFields(blockId).data?.footerStyle == 'classic'"
      class="footerWrapper footerWithColor"
      [ngClass]="getBlockFields(blockId).footerMenu"
      [ngStyle]="{ 'background-color': getBlockFields(blockId).bgColor ? getBlockFields(blockId).bgColor : '#3064F8' }"
    >
      <div class="navbar" [ngClass]="getBlockFields(blockId).data?.colorSource ? getBlockFields(blockId).data?.colorSource : 'globalColors'" [ngStyle]="{ 'background-color': getBlockFields(blockId).data?.bgColor ? getBlockFields(blockId).data?.bgColor : '#3064F8' }">
        <div class="nav-item" *ngFor="let menuItem of getBlockFields(blockId).data?.menuItems">
          <i class="material-icons" [ngStyle]="{ color: menuItem.color }">{{ menuItem.icon }}</i>
          <p *ngIf="menuItem.menuText && menuItem.menuText !== ''" [ngStyle]="{ color: menuItem.color }">
            {{ menuItem.menuText }}
          </p>
        </div>
      </div>
    </div>

    <!-- Circle Style -->
    <div
      *ngIf="getBlockFields(blockId) && getBlockFields(blockId).data?.footerMenu && getBlockFields(blockId).data?.footerStyle == 'circle'"
      class="footerWrapper footerWithColor"
      [ngClass]="getBlockFields(blockId).data?.footerMenu"
      [ngStyle]="{ 'background-color': getBlockFields(blockId).data?.bgColor ? getBlockFields(blockId).data?.bgColor : '#3064F8' }"
    >
      <div class="CircleNavbar" [ngClass]="getBlockFields(blockId).data?.colorSource ? getBlockFields(blockId).data?.colorSource : 'globalColors'" [ngStyle]="{ 'background-color': getBlockFields(blockId).data?.bgColor ? getBlockFields(blockId).data?.bgColor : '#3064F8' }">
        <div class="CircleNavItem" *ngFor="let menuItem of getBlockFields(blockId).data?.menuItems; let i = index" [ngClass]="getBlockFields(blockId).data?.circleMainItem == i ? 'special-icon' : ''">
          <div
            *ngIf="getBlockFields(blockId).data?.circleMainItem == i"
            class="shopping-bag-wrapper"
            [ngStyle]="{
              'background-color': getBlockFields(blockId).data?.colorSource === 'customColors' ? getBlockFields(blockId).data?.circleMainBgColor : ''
            }"
          >
            <i class="material-icons-outlined" [ngStyle]="{ color: menuItem.color }">{{ menuItem.icon }}</i>
          </div>
          <div *ngIf="getBlockFields(blockId).data?.circleMainItem !== i">
            <i class="material-icons-outlined" [ngStyle]="{ color: menuItem.color }">{{ menuItem.icon }}</i>
            <p *ngIf="menuItem.menuText && menuItem.menuText !== ''" [ngStyle]="{ color: menuItem.color }">
              {{ menuItem.menuText }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div
      *ngIf="getBlockFields(blockId) && !getBlockFields(blockId).data?.footerMenu && getBlockFields(blockId).footerMenu && getBlockFields(blockId).data?.footerStyle == 'circle'"
      class="footerWrapper rowan footerWithColor"
      [ngClass]="getBlockFields(blockId).footerMenu"
      [ngStyle]="{ 'background-color': getBlockFields(blockId).bgColor ? getBlockFields(blockId).bgColor : '#3064F8' }"
    >
      <div class="CircleNavbar" [ngClass]="getBlockFields(blockId).data?.colorSource ? getBlockFields(blockId).data?.colorSource : 'globalColors'" [ngStyle]="{ 'background-color': getBlockFields(blockId).data?.bgColor ? getBlockFields(blockId).data?.bgColor : '#3064F8' }">
        <div class="CircleNavItem" *ngFor="let menuItem of getBlockFields(blockId).data?.menuItems; let i = index" [ngClass]="getBlockFields(blockId).data?.circleMainItem == i ? 'special-icon' : ''">
          <div
            *ngIf="getBlockFields(blockId).data?.circleMainItem == i"
            class="shopping-bag-wrapper"
            [ngStyle]="{
              'background-color': getBlockFields(blockId).data?.colorSource === 'customColors' ? getBlockFields(blockId).data?.circleMainBgColor : ''
            }"
          >
            <i class="material-icons" [ngStyle]="{ color: menuItem.color }">{{ menuItem.icon }}</i>
          </div>
          <div *ngIf="getBlockFields(blockId).data?.circleMainItem !== i">
            <i class="material-icons" [ngStyle]="{ color: menuItem.color }">{{ menuItem.icon }}</i>
            <p *ngIf="menuItem.menuText && menuItem.menuText !== ''" [ngStyle]="{ color: menuItem.color }">
              {{ menuItem.menuText }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Expand Style -->
    <div
      *ngIf="getBlockFields(blockId) && getBlockFields(blockId).data?.footerMenu && getBlockFields(blockId).data?.footerStyle == 'expand'"
      class="footerWrapper footerWithColor expandFooterWrapper"
      [ngClass]="getBlockFields(blockId).data?.footerMenu"
      [ngStyle]="{ 'background-color': getBlockFields(blockId).data?.bgColor ? getBlockFields(blockId).data?.bgColor : '#3064F8' }"
    >
      <div
        class="expand-navbar"
        [ngClass]="{
          'expand-navbar': getBlockFields(blockId).data?.menuItems?.length <= 3,
          expandHeight: getBlockFields(blockId).data?.menuItems?.length > 3,
          globalColors: getBlockFields(blockId).data?.colorSource !== 'customColors',
          customColors: getBlockFields(blockId).data?.colorSource === 'customColors'
        }"
        [ngStyle]="{
          'background-color': getBlockFields(blockId).data?.bgColor ? getBlockFields(blockId).data?.bgColor : '#3064F8'
        }"
      >
        <div [ngClass]="getBlockFields(blockId).data?.colorSource ? getBlockFields(blockId).data?.colorSource : 'globalColors'" class="expand-nav-item" *ngFor="let menuItem of getBlockFields(blockId).data?.menuItems">
          <i class="material-icons-outlined" [ngStyle]="{ color: menuItem.color }">{{ menuItem.icon }}</i>
          <p *ngIf="menuItem.menuText && menuItem.menuText !== ''" [ngStyle]="{ color: menuItem.color }">
            {{ menuItem.menuText }}
          </p>
        </div>
      </div>
    </div>
    <div
      *ngIf="getBlockFields(blockId) && !getBlockFields(blockId).data?.footerMenu && getBlockFields(blockId).footerMenu && getBlockFields(blockId).data?.footerStyle == 'expand'"
      class="footerWrapper footerWithColor expandFooterWrapper"
      [ngClass]="getBlockFields(blockId).footerMenu"
      [ngStyle]="{ 'background-color': getBlockFields(blockId).bgColor ? getBlockFields(blockId).bgColor : '#3064F8' }"
    >
      <div [ngClass]="getBlockFields(blockId).data?.colorSource ? getBlockFields(blockId).data?.colorSource : 'globalColors'" class="expand-nav-item" *ngFor="let menuItem of getBlockFields(blockId).data?.menuItems">
        <i class="material-icons" [ngStyle]="{ color: menuItem.color }">{{ menuItem.icon }}</i>
        <p *ngIf="menuItem.menuText && menuItem.menuText !== ''" [ngStyle]="{ color: menuItem.color }">
          {{ menuItem.menuText }}
        </p>
      </div>
    </div>
    <!-- <div *ngIf="getBlockFields(blockId).data?.gFooterBanners[gFooterBanner.index].status">
      <img src="../../../assets/images/admob_sample.jpeg" />
    </div> -->
    <img src="../../../assets/images/adsbanner.gif" *ngIf="blockDataService.gAdMobActiveFooter" />
  </div>
  <!-- Data and Style Tabs -->
  <div class="tabsContainer" *ngIf="checkSettings() && builderType === 'website'">
    <a (click)="showDataTab()" [ngClass]="checkData() ? 'active' : ''">{{ 'Data' | translate }}</a>
    <a (click)="showStyleTab()" [ngClass]="checkStyle() ? 'active' : ''">{{ 'Style' | translate }}</a>
  </div>
  <div class="previewFields" *ngIf="checkData()">
    <mat-progress-bar mode="indeterminate" *ngIf="showProgress"></mat-progress-bar>

    <!-- Global Footer Toggle (Mobile Builder Only) -->
    <div class="sectionSettings" *ngIf="builderType !== 'website' && !builderService.globals">
      <div class="sectionHeader">{{ 'Activate Global Settings' | translate }}</div>
      <ul>
        <li>
          <mat-slide-toggle (change)="toggleChanged(blockId, 'global_footer')" [(ngModel)]="blockFieldsService.readGlobalFooter">
            <span>{{ 'Activate Global Footer' | translate }}</span>
          </mat-slide-toggle>
        </li>
      </ul>
    </div>

    <!-- Website Builder Footer Settings -->
    <div class="sectionSettings" *ngIf="builderType === 'website'">
      <div class="sectionHeader">{{ 'Footer Settings' | translate }}</div>
      <!-- Footer Logo Upload Section -->
      <div class="sectionHeader">{{ 'Footer Logo' | translate }}</div>
      <ul>
        <li>
          <label class="fileUpload" for="footerLogo">
            {{ 'Upload Footer Logo' | translate }}
            <input type="file" id="footerLogo" accept="image/png,image/jpeg,image/jpg" (change)="processFile($event, 'images', 'footerLogo', blockId)" />
          </label>
        </li>
        <li *ngIf="getBlockFields(blockId).data?.footerLogoUrl">
          <div class="logoPreview">
            <img [src]="getBlockFields(blockId).data?.footerLogoUrl" [alt]="'Footer Logo' | translate" style="max-height: 50px; max-width: 200px;" />
          </div>
        </li>
        <li>
          <div class="imageDiContainer">
            <div>
              <span class="imageDimensions">{{ 'Recommended Dimensions' | translate }}</span>
              <span class="imageDimensions">{{ 'Width: 150-200px, Height: 40-60px' | translate }}</span>
            </div>
            <span class="imageDimensions">{{ 'PNG or JPG format' | translate }}</span>
          </div>
        </li>
      </ul>
      <ul>
        <li>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Footer Description' | translate }}</mat-label>
            <textarea matInput rows="3"
              (change)="queryChange('description', blockId, $event, 'text', 0, '')"
              [value]="getBlockFields(blockId).data?.description || ''"></textarea>
          </mat-form-field>
        </li>
        <li class="contentContainerColor">
          <label>{{ 'Background Color' | translate }}</label>
          <mat-form-field>
            <p class="colorPickerValue">{{ getBlockFields(blockId).data?.bgColor || '#f8f9fa' }}</p>
            <label for="bgColor" class="colorLabel">
              <input type="color" id="bgColor" matInput class="colorPicker" name="bgColor"
                (change)="queryChange('bgColor', blockId, $event, 'text', 0, '')"
                [value]="getBlockFields(blockId).data?.bgColor || '#f8f9fa'" />
            </label>
          </mat-form-field>
        </li>
        <li class="contentContainerColor">
          <label>{{ 'Text Color' | translate }}</label>
          <mat-form-field>
            <p class="colorPickerValue">{{ getBlockFields(blockId).data?.textColor || '#333333' }}</p>
            <label for="textColor" class="colorLabel">
              <input type="color" id="textColor" matInput class="colorPicker" name="textColor"
                (change)="queryChange('textColor', blockId, $event, 'text', 0, '')"
                [value]="getBlockFields(blockId).data?.textColor || '#333333'" />
            </label>
          </mat-form-field>
        </li>
        <li>
          <mat-slide-toggle
            (change)="queryChange('showLogo', blockId, $event, 'toggle', 0, '')"
            [checked]="getBlockFields(blockId).data?.showLogo !== false">
            <span>{{ 'Show Logo' | translate }}</span>
          </mat-slide-toggle>
        </li>
      </ul>

      <!-- Footer Background Image Section -->
      <div class="sectionHeader">{{ 'Background Image' | translate }}</div>
      <ul>
        <li>
          <label class="fileUpload" for="footerBgImage">
            {{ 'Upload Background Image' | translate }}
            <input type="file" id="footerBgImage" accept="image/png,image/jpeg,image/jpg" (change)="processFile($event, 'images', 'footerBgImage', blockId)" />
          </label>
        </li>
        <li *ngIf="getBlockFields(blockId).data?.footerBgImageUrl">
          <div class="logoPreview">
            <img [src]="getBlockFields(blockId).data?.footerBgImageUrl" [alt]="'Background Image' | translate" style="max-height: 100px; max-width: 200px;" />
          </div>
        </li>
        <li *ngIf="getBlockFields(blockId).data?.footerBgImageUrl">
          <button class="deleteMenuItem material-icons-outlined" (click)="removeFooterBgImage(blockId)">delete</button>
          <span>{{ 'Remove Background Image' | translate }}</span>
        </li>
        <li>
          <div class="imageDiContainer">
            <div>
              <span class="imageDimensions">{{ 'Recommended Dimensions' | translate }}</span>
              <span class="imageDimensions">{{ 'Width: 1920px, Height: 400-600px' | translate }}</span>
            </div>
            <span class="imageDimensions">{{ 'PNG or JPG format' | translate }}</span>
          </div>
        </li>
      </ul>

      <!-- Product Links Section -->
      <div class="sectionHeader mb-3">{{ 'Product Links' | translate }}</div>
      <ul>
        <li>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Section Title' | translate }}</mat-label>
            <input matInput
              (change)="queryChange('productLinksTitle', blockId, $event, 'text', 0, '')"
              [value]="getBlockFields(blockId).data?.productLinksTitle || 'Products'"
              [placeholder]="'Products' | translate" />
          </mat-form-field>
        </li>
        <li *ngFor="let link of getBlockFields(blockId).data?.productLinks; let i = index" class="linkItem">
          <button class="deleteMenuItem material-icons-outlined" (click)="deleteFooterLink(blockId, i, 'productLinks')">delete</button>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Link Name' | translate }}</mat-label>
            <input matInput
              (change)="queryChange('name', blockId, $event, 'multilevelText', i, 'productLinks')"
              [value]="link.name" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Page' | translate }}</mat-label>
            <mat-select (selectionChange)="queryChange('url', blockId, $event, 'multilevelSelect', i, 'productLinks')"
              [value]="link.url || 'home'">
              <mat-option *ngFor="let page of availablePages" [value]="'/' + page.name">
                {{ page.title || page.name }}
              </mat-option>
              <mat-option value="externalLink">
                {{ 'External Link' | translate }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" *ngIf="link.url === 'externalLink'">
            <mat-label>{{ 'URL' | translate }}</mat-label>
            <input matInput placeholder="https://example.com"
              (change)="queryChange('externalUrl', blockId, $event, 'multilevelText', i, 'productLinks')"
              [value]="link.externalUrl || ''" />
          </mat-form-field>
        </li>
        <li>
          <button class="addItem" (click)="addFooterLink(blockId, 'productLinks')">{{ 'Add Product Link' | translate }}</button>
        </li>
      </ul>

      <!-- Company Links Section -->
      <div class="sectionHeader mb-3">{{ 'Company Links' | translate }}</div>
      <ul>
        <li>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Section Title' | translate }}</mat-label>
            <input matInput
              (change)="queryChange('companyLinksTitle', blockId, $event, 'text', 0, '')"
              [value]="getBlockFields(blockId).data?.companyLinksTitle || 'Company'"
              [placeholder]="'Company' | translate" />
          </mat-form-field>
        </li>
        <li *ngFor="let link of getBlockFields(blockId).data?.companyLinks; let i = index" class="linkItem">
          <button class="deleteMenuItem material-icons-outlined" (click)="deleteFooterLink(blockId, i, 'companyLinks')">delete</button>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Link Name' | translate }}</mat-label>
            <input matInput
              (change)="queryChange('name', blockId, $event, 'multilevelText', i, 'companyLinks')"
              [value]="link.name" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Page' | translate }}</mat-label>
            <mat-select (selectionChange)="queryChange('url', blockId, $event, 'multilevelSelect', i, 'companyLinks')"
              [value]="link.url || 'home'">
              <mat-option *ngFor="let page of availablePages" [value]="'/' + page.name">
                {{ page.title || page.name }}
              </mat-option>
              <mat-option value="externalLink">
                {{ 'External Link' | translate }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" *ngIf="link.url === 'externalLink'">
            <mat-label>{{ 'URL' | translate }}</mat-label>
            <input matInput placeholder="https://example.com"
              (change)="queryChange('externalUrl', blockId, $event, 'multilevelText', i, 'companyLinks')"
              [value]="link.externalUrl || ''" />
          </mat-form-field>
        </li>
        <li>
          <button class="addItem" (click)="addFooterLink(blockId, 'companyLinks')">{{ 'Add Company Link' | translate }}</button>
        </li>
      </ul>

      <!-- Social Media Links Section -->
      <div class="sectionHeader">{{ 'Social Media' | translate }}</div>
      <ul class="socialMediaList">
        <li class="socialMediaItem">
          <div class="socialMediaIcon">
          <svg width="25" height="25" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M0.933594 5.59147C0.933594 7.89809 2.61113 9.80862 4.82455 10.2047L4.85205 10.1823L4.84785 10.1814V6.89623H3.68289V5.59147H4.84785V4.56631C4.84785 3.40135 5.59343 2.74898 6.66519 2.74898C6.99138 2.74898 7.36416 2.79557 7.69035 2.84217V4.03043H7.08457C6.52539 4.03043 6.3856 4.31002 6.3856 4.68281V5.59147H7.62045L7.41076 6.89623H6.3856V10.1814L6.34366 10.1889L6.3623 10.2047C8.57572 9.80862 10.2533 7.89809 10.2533 5.59147C10.2533 3.02857 8.15633 0.931641 5.59343 0.931641C3.03052 0.931641 0.933594 3.02857 0.933594 5.59147Z" fill="#8A8A8A"/>
          </svg>
          </div>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Facebook URL' | translate }}</mat-label>
            <input matInput
              (change)="queryChange('facebookUrl', blockId, $event, 'text', 0, '')"
              [value]="getBlockFields(blockId).data?.socialMedia?.facebookUrl || ''"
              placeholder="https://facebook.com/yourpage" />
          </mat-form-field>
        </li>
        <li class="socialMediaItem">
          <div class="socialMediaIcon">
            <svg width="25" height="25" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.59063 1.11719C4.37581 1.11719 4.22343 1.12231 3.74626 1.14421C3.27003 1.16565 2.94477 1.2416 2.66052 1.35204C2.3621 1.46434 2.09176 1.64038 1.86835 1.86789C1.64069 2.09126 1.46449 2.3616 1.35204 2.66006C1.2416 2.94477 1.16565 3.2705 1.14421 3.74626C1.12185 4.22343 1.11719 4.37534 1.11719 5.59063C1.11719 6.80545 1.12231 6.95782 1.14421 7.43499C1.16565 7.91122 1.2416 8.23648 1.35204 8.52073C1.46435 8.81915 1.64039 9.08949 1.86789 9.3129C2.11672 9.5622 2.36649 9.71504 2.66006 9.82921C2.94477 9.93965 3.27003 10.0156 3.7458 10.037C4.22343 10.0589 4.37581 10.0641 5.59063 10.0641C6.80545 10.0641 6.95782 10.0589 7.43499 10.037C7.91122 10.0156 8.23648 9.93965 8.52073 9.82921C8.81915 9.7169 9.08949 9.54086 9.3129 9.31337C9.54056 9.09 9.71676 8.81966 9.82921 8.5212C9.93965 8.23648 10.0156 7.91076 10.037 7.43545C10.0589 6.95782 10.0641 6.80545 10.0641 5.59063C10.0641 4.37581 10.0589 4.22343 10.037 3.74626C10.0151 3.27003 9.93965 2.94477 9.82921 2.66052C9.7169 2.3621 9.54086 2.09177 9.31337 1.86835C9.09001 1.64068 8.81966 1.46448 8.5212 1.35204C8.23648 1.2416 7.91076 1.16565 7.43499 1.14421C6.95782 1.12185 6.80591 1.11719 5.59063 1.11719ZM5.59063 1.92334C6.78494 1.92334 6.9266 1.928 7.39864 1.94943C7.83434 1.969 8.07106 2.04216 8.22902 2.10321C8.43778 2.18429 8.5869 2.28121 8.74347 2.43778C8.90004 2.59435 8.99696 2.74347 9.07804 2.95223C9.13909 3.10973 9.21178 3.34692 9.23182 3.78308C9.25325 4.25465 9.25792 4.39631 9.25792 5.59063C9.25792 6.78494 9.25325 6.9266 9.23182 7.39864C9.21178 7.83434 9.13909 8.07152 9.07804 8.22902C9.00623 8.4234 8.89174 8.59919 8.743 8.74347C8.59881 8.89198 8.42319 9.0063 8.22902 9.07804C8.07106 9.13909 7.83434 9.21225 7.39818 9.23182C6.9266 9.25325 6.78494 9.25792 5.59016 9.25792C4.39585 9.25792 4.25465 9.25325 3.78308 9.23182C3.34692 9.21225 3.10973 9.13909 2.95223 9.07804C2.7579 9.00637 2.58211 8.89204 2.43778 8.74347C2.28922 8.59915 2.17489 8.42335 2.10321 8.22902C2.04216 8.07152 1.969 7.83434 1.94943 7.39818C1.92753 6.9266 1.92334 6.78494 1.92334 5.59063C1.92334 4.39631 1.928 4.25465 1.94943 3.78261C1.969 3.34692 2.04216 3.1102 2.10321 2.95223C2.18429 2.74347 2.28121 2.59435 2.43778 2.43778C2.58211 2.28922 2.7579 2.17489 2.95223 2.10321C3.10973 2.04216 3.34692 1.969 3.78308 1.94943C4.25465 1.928 4.39631 1.92334 5.59063 1.92334ZM5.59063 7.08177C5.19515 7.08177 4.81587 6.92467 4.53623 6.64503C4.25658 6.36538 4.09948 5.9861 4.09948 5.59063C4.09948 5.19515 4.25658 4.81587 4.53623 4.53623C4.81587 4.25658 5.19515 4.09948 5.59063 4.09948C5.9861 4.09948 6.36538 4.25658 6.64503 4.53623C6.92467 4.81587 7.08177 5.19515 7.08177 5.59063C7.08177 5.9861 6.92467 6.36538 6.64503 6.64503C6.36538 6.92467 5.9861 7.08177 5.59063 7.08177ZM5.59063 3.29333C5.28894 3.29333 4.99021 3.35275 4.71149 3.4682C4.43277 3.58365 4.17952 3.75287 3.96619 3.96619C3.75287 4.17952 3.58365 4.43277 3.4682 4.71149C3.35275 4.99021 3.29333 5.28894 3.29333 5.59063C3.29333 5.89231 3.35275 6.19104 3.4682 6.46976C3.58365 6.74849 3.75287 7.00174 3.96619 7.21506C4.17952 7.42839 4.43277 7.5976 4.71149 7.71305C4.99021 7.8285 5.28894 7.88792 5.59063 7.88792C6.19991 7.88792 6.78423 7.64589 7.21506 7.21506C7.64589 6.78423 7.88792 6.19991 7.88792 5.59063C7.88792 4.98135 7.64589 4.39702 7.21506 3.96619C6.78423 3.53537 6.19991 3.29333 5.59063 3.29333ZM8.51514 3.20293C8.51514 3.3453 8.45858 3.48184 8.35791 3.58251C8.25724 3.68318 8.1207 3.73974 7.97833 3.73974C7.83595 3.73974 7.69941 3.68318 7.59874 3.58251C7.49807 3.48184 7.44151 3.3453 7.44151 3.20293C7.44151 3.06056 7.49807 2.92402 7.59874 2.82334C7.69941 2.72267 7.83595 2.66612 7.97833 2.66612C8.1207 2.66612 8.25724 2.72267 8.35791 2.82334C8.45858 2.92402 8.51514 3.06056 8.51514 3.20293Z" fill="#8A8A8A"/>
            </svg>

          </div>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Instagram URL' | translate }}</mat-label>
            <input matInput
              (change)="queryChange('instagramUrl', blockId, $event, 'text', 0, '')"
              [value]="getBlockFields(blockId).data?.socialMedia?.instagramUrl || ''"
              placeholder="https://instagram.com/yourpage" />
          </mat-form-field>
        </li>
        <li class="socialMediaItem">
          <div class="socialMediaIcon">
          <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M21.959 13.7194V21.0984H17.681V14.2134C17.681 12.4834 17.062 11.3034 15.514 11.3034C14.332 11.3034 13.628 12.0994 13.319 12.8684C13.206 13.1434 13.177 13.5264 13.177 13.9114V21.0984H8.897C8.897 21.0984 8.955 9.43837 8.897 8.22937H13.177V10.0534L13.149 10.0954H13.177V10.0534C13.745 9.17837 14.76 7.92737 17.033 7.92737C19.848 7.92737 21.959 9.76737 21.959 13.7194ZM4.421 2.02637C2.958 2.02637 2 2.98637 2 4.24937C2 5.48437 2.93 6.47337 4.365 6.47337H4.393C5.886 6.47337 6.813 5.48437 6.813 4.24937C6.787 2.98637 5.887 2.02637 4.422 2.02637H4.421ZM2.254 21.0984H6.532V8.22937H2.254V21.0984Z" fill="#8A8A8A"/>
          </svg>
 
          </div>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'LinkedIn URL' | translate }}</mat-label>
            <input matInput
              (change)="queryChange('linkedinUrl', blockId, $event, 'text', 0, '')"
              [value]="getBlockFields(blockId).data?.socialMedia?.linkedinUrl || ''"
              placeholder="https://linkedin.com/company/yourpage" />
          </mat-form-field>
        </li>
        <li class="socialMediaItem">
          <div class="socialMediaIcon">
          <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M22 5.90668C21.2504 6.23405 20.4565 6.44871 19.644 6.54368C20.4968 6.04291 21.138 5.24878 21.448 4.30968C20.64 4.78 19.7587 5.11128 18.841 5.28968C18.4545 4.88488 17.9897 4.56306 17.4748 4.34385C16.9598 4.12464 16.4056 4.01264 15.846 4.01468C13.58 4.01468 11.743 5.82468 11.743 8.05468C11.743 8.37068 11.779 8.67968 11.849 8.97468C10.2236 8.89737 8.63212 8.48208 7.17617 7.75531C5.72022 7.02855 4.43176 6.00626 3.393 4.75368C3.02883 5.36808 2.83742 6.06946 2.839 6.78368C2.8397 7.45164 3.00683 8.10891 3.32529 8.69607C3.64375 9.28323 4.1035 9.78179 4.663 10.1467C4.01248 10.1257 3.37602 9.952 2.805 9.63968V9.68968C2.805 11.6477 4.22 13.2807 6.095 13.6527C5.74261 13.7462 5.37958 13.7936 5.015 13.7937C4.75 13.7937 4.493 13.7687 4.242 13.7187C4.51008 14.5266 5.02311 15.231 5.70982 15.734C6.39653 16.237 7.22284 16.5137 8.074 16.5257C6.61407 17.6502 4.82182 18.2577 2.979 18.2527C2.647 18.2527 2.321 18.2327 2 18.1967C3.88125 19.3874 6.06259 20.018 8.289 20.0147C15.836 20.0147 19.962 13.8577 19.962 8.51868L19.948 7.99568C20.7529 7.42935 21.4481 6.72152 22 5.90668Z" fill="#8A8A8A"/>
          </svg>

          </div>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Twitter (X) URL' | translate }}</mat-label>
            <input matInput
              (change)="queryChange('twitterUrl', blockId, $event, 'text', 0, '')"
              [value]="getBlockFields(blockId).data?.socialMedia?.twitterUrl || ''"
              placeholder="https://twitter.com/yourpage" />
          </mat-form-field>
        </li>
        <li class="socialMediaItem">
          <div class="socialMediaIcon">
           <svg width="25" height="25" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.33198 4.73695C8.90003 4.77702 8.46534 4.69868 8.07455 4.51035C7.68377 4.32202 7.35167 4.03081 7.1139 3.66798V7.34599C7.1138 7.88353 6.95432 8.40898 6.65562 8.85589C6.35692 9.30281 5.93241 9.65112 5.43576 9.85679C4.93912 10.0625 4.39264 10.1162 3.86543 10.0113C3.33822 9.90646 2.85395 9.64759 2.47384 9.26749C2.09374 8.88739 1.83488 8.40312 1.72999 7.8759C1.62509 7.34869 1.67888 6.80222 1.88455 6.30557C2.09022 5.80893 2.43853 5.38441 2.88544 5.08571C3.33236 4.78701 3.8578 4.62753 4.39535 4.62744C4.4522 4.62744 4.50765 4.63256 4.56357 4.63629V5.97553C4.50765 5.96901 4.45313 5.95875 4.39582 5.95875C4.0279 5.95875 3.67505 6.10491 3.41489 6.36506C3.15474 6.62522 3.00858 6.97807 3.00858 7.34599C3.00858 7.7139 3.15474 8.06675 3.41489 8.32691C3.67505 8.58706 4.0279 8.73322 4.39582 8.73322C5.16189 8.73322 5.8385 8.12977 5.8385 7.36323L5.85248 1.11719H7.13393C7.19244 1.67392 7.44478 2.19238 7.84683 2.58191C8.24889 2.97144 8.77506 3.20726 9.33337 3.24813V4.73695" fill="#8A8A8A"/>
          </svg>          </div>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'TikTok URL' | translate }}</mat-label>
            <input matInput
              (change)="queryChange('tiktokUrl', blockId, $event, 'text', 0, '')"
              [value]="getBlockFields(blockId).data?.socialMedia?.tiktokUrl || ''"
              placeholder="https://tiktok.com/@yourpage" />
          </mat-form-field>
        </li>
      </ul>
    </div>

    <!-- Floating Social Settings (website, global footer editor, and home footer without global footer) -->
    <div class="sectionSettings" *ngIf="builderType === 'website' || !blockFieldsService.readGlobalFooter || builderService.globals">
      <div class="sectionHeader">{{ 'Floating Social' | translate }}</div>
      <ul>
        <li>
          <mat-slide-toggle
            (change)="toggleFooterSocial(blockId, $event)"
            [checked]="getBlockFields(blockId).data?.floatingSocial?.enabled">
            <span>{{ 'Enable Floating Social Icons' | translate }}</span>
          </mat-slide-toggle>
        </li>
        <ng-container *ngIf="getBlockFields(blockId).data?.floatingSocial?.enabled">
          <li>
            <mat-form-field appearance="outline">
              <mat-label>{{ 'Position' | translate }}</mat-label>
              <mat-select
                (selectionChange)="footerSocialStyleChange('position-x', blockId, $event, 'select')"
                [value]="getBlockFields(blockId).data?.floatingSocial?.style?.['position-x'] || 'right'">
                <mat-option value="right">{{ 'Right' | translate }}</mat-option>
                <mat-option value="left">{{ 'Left' | translate }}</mat-option>
              </mat-select>
            </mat-form-field>
          </li>
          <li class="contentContainerColor">
            <label>{{ 'Icon Color' | translate }}</label>
            <mat-form-field>
              <p class="colorPickerValue">{{ getBlockFields(blockId).data?.floatingSocial?.style?.['background-color'] || '#567EDC' }}</p>
              <label for="socialBtnColor" class="colorLabel">
                <input
                  type="color"
                  id="socialBtnColor"
                  matInput
                  class="colorPicker"
                  name="socialBtnColor"
                  (change)="footerSocialStyleChange('background-color', blockId, $event, 'text')"
                  [value]="getBlockFields(blockId).data?.floatingSocial?.style?.['background-color'] || '#567EDC'" />
              </label>
            </mat-form-field>
          </li>
        </ng-container>
      </ul>
      <ng-container *ngIf="getBlockFields(blockId).data?.floatingSocial?.enabled">
        <ul>
          <li *ngFor="let social of getBlockFields(blockId).data?.floatingSocial?.socials; let i = index" class="socialItem">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'Platform' | translate }}</mat-label>
              <mat-select [value]="social.platform" (selectionChange)="footerSocialPlatformChange(blockId, i, $event)">
                <mat-option *ngFor="let p of socialPlatforms" [value]="p.value">{{ p.label }}</mat-option>
              </mat-select>
            </mat-form-field>
            <ng-container *ngIf="social.platform === 'custom'">
              <div class="customIconUpload">
                <label class="uploadLabel">{{ 'Icon Image' | translate }}</label>
                <img *ngIf="social.image" [src]="social.image" class="customIconPreview" [alt]="'Custom icon' | translate" />
                <label class="stacksBtn blue uploadBtn">
                  <mat-icon>upload</mat-icon>
                  {{ 'Upload Image' | translate }}
                  <input type="file" accept="image/*" hidden (change)="uploadSocialImage(blockId, i, $event)" />
                </label>
              </div>
            </ng-container>
            <mat-form-field appearance="outline">
              <mat-label>{{ 'URL' | translate }}</mat-label>
              <input matInput [value]="social.url" (keyup)="footerSocialUrlChange(blockId, i, $event)" placeholder="https://" />
            </mat-form-field>
            <button class="stacksBtn red" (click)="removeFooterSocial(blockId, i)">
              <mat-icon>delete</mat-icon>
              {{ 'Remove' | translate }}
            </button>
            <mat-divider></mat-divider>
          </li>
        </ul>
        <button class="stacksBtn green addSocialBtn" (click)="addFooterSocial(blockId)">
          <mat-icon>add</mat-icon>
          {{ 'Add Social' | translate }}
        </button>
      </ng-container>
    </div>

    <!-- Mobile Builder Footer Settings -->
    <div class="sectionSettings" *ngIf="builderType !== 'website' && (!blockFieldsService.readGlobalFooter || builderService.globals)">
      <div class="sectionHeader">{{ 'Footer Settings' | translate }}</div>
      <ul>
        <li>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Footer Activation' | translate }}</mat-label>
            <mat-select (selectionChange)="queryChange('footerMenu', blockId, $event, 'select', 0, '')" [(value)]="getBlockFields(blockId).data.footerMenu">
              <mat-option value="active">
                {{ 'Enable Footer Menu' | translate }}
              </mat-option>
              <mat-option value="inactive">
                {{ 'Disable Footer Menu' | translate }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </li>
        <li>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Footer Style' | translate }}</mat-label>
            <mat-select (selectionChange)="queryChange('footerStyle', blockId, $event, 'select', 0, '')" [(value)]="getBlockFields(blockId).data.footerStyle">
              <mat-option value="classic">
                {{ 'Classic Style' | translate }}
              </mat-option>
              <mat-option value="expand">
                {{ 'Expand Style' | translate }}
              </mat-option>
              <mat-option value="circle">
                {{ 'Circle Style' | translate }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </li>
        <li *ngIf="getBlockFields(blockId).data.footerStyle == 'circle'">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Circle Main Item' | translate }}</mat-label>
            <mat-select (selectionChange)="queryChange('circleMainItem', blockId, $event, 'select', 0, '')" [(value)]="getBlockFields(blockId).data.circleMainItem">
              <mat-option [value]="i" *ngFor="let menuItem of getBlockFields(blockId).data?.menuItems; let i = index">
                {{ menuItem.menuText }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </li>
        <li class="contentContainerColor">
          <label>{{ 'Background Color' | translate }}</label>
          <mat-form-field>
            <p class="colorPickerValue">{{ getBlockFields(blockId).data?.bgColor }}</p>
            <label for="bgColor" class="colorLabel">
              <input type="color" id="bgColor" matInput class="colorPicker" name="bgColor" (change)="queryChange('bgColor', blockId, $event, 'text', 0, '')" value="{{ getBlockFields(blockId).data?.bgColor }}" />
            </label>
          </mat-form-field>
        </li>
        <li class="contentCenter">
          <!-- <mat-label>{{ 'Color Source' | translate }}</mat-label> -->
          <mat-form-field>
            <mat-select (selectionChange)="queryChange('colorSource', blockId, $event, 'select', 0, '')" value="{{ getBlockFields(blockId).data?.colorSource ? getBlockFields(blockId).data?.colorSource : '' }}">
              <mat-option value="" disabled>
                {{ 'Select Color Source' | translate }}
              </mat-option>
              <mat-option value="globalColors">
                {{ 'Global Colors' | translate }}
              </mat-option>
              <mat-option value="customColors">
                {{ 'Custom Color' | translate }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </li>
        <li class="contentCenter" *ngIf="getBlockFields(blockId).data?.colorSource == 'customColors' && getBlockFields(blockId).data?.footerStyle == 'circle'">
          <mat-form-field>
            <mat-label>{{ 'Main Circle Background Color' | translate }}</mat-label>
            <p class="colorPickerValue">{{ getBlockFields(blockId).data?.circleMainBgColor }}</p>
            <label for="circleMainBgColor" class="colorLabel">
              <input type="color" id="circleMainBgColor" matInput class="colorPicker" name="circleMainBgColor" (change)="queryChange('circleMainBgColor', blockId, $event, 'text', 0, '')" value="{{ getBlockFields(blockId).data?.circleMainBgColor }}" />
            </label>
          </mat-form-field>
        </li>
        <ul class="singleMenuSettings">
          <li *ngFor="let menuItem of getBlockFields(blockId).data?.menuItems">
            <button *ngIf="menuItem.index !== 0" class="deleteMenuItem material-icons-outlined" (click)="deleteMenuItem(blockId, menuItem.index)">delete</button>
            <div class="menuItemData" [ngClass]="menuItem.index == 0 ? 'firstMenuItemData' : ''">
              <div class="MenuItemContainer">
                <div class="MenuColorContainer">
                  <button class="stacksBtn green dialogSelectorBtn iconSelectorBtn" (click)="selectIconDialog(blockId, menuItem.index)">{{ 'Change Icon' | translate }}</button>
                  <label for="color" class="colorLabel">
                    <input
                      type="color"
                      id="color"
                      matInput
                      class="colorPicker"
                      name="color"
                      *ngIf="getBlockFields(blockId).data?.colorSource == 'customColors'"
                      (change)="queryChange('color', blockId, $event, 'multilevelText', menuItem.index, 'menuItems')"
                      value="{{ getBlockFields(blockId).data?.menuItems[menuItem.index]?.color ? getBlockFields(blockId).data?.menuItems[menuItem.index]?.color : '#ffffff' }}"
                    />
                  </label>
                </div>
                <label>{{ 'Menu Item Text' | translate }}</label>
                <mat-form-field>
                  <input
                    type="text"
                    matInput
                    class="menuText"
                    name="menuText"
                    (change)="queryChange('menuText', blockId, $event, 'multilevelText', menuItem.index, 'menuItems')"
                    value="{{ getBlockFields(blockId).data?.menuItems[menuItem.index]?.menuText ? getBlockFields(blockId).data?.menuItems[menuItem.index]?.menuText : 'Home' }}"
                  />
                </mat-form-field>
              </div>

              <ul class="menuLinker">
                <li>
                  <mat-form-field appearance="outline">
                    <mat-label>{{ 'Link Type' | translate }}</mat-label>
                    <mat-select (selectionChange)="queryChange('link', blockId, $event, 'multilevelSelect', menuItem.index, 'menuItems')" value="{{ getBlockFields(blockId).data?.menuItems[menuItem.index].link }}">
                      <mat-option value="home">
                        {{ 'Home' | translate }}
                      </mat-option>
                      <mat-option value="products">
                        {{ 'Products' | translate }}
                      </mat-option>
                      <mat-option value="allProductsCategories">
                        {{ 'All Products Categories' | translate }}
                      </mat-option>
                      <mat-option value="productsCategories">
                        {{ 'Product Category' | translate }}
                      </mat-option>
                      <mat-option value="productsSubCategories">
                        {{ 'Product Sub Category' | translate }}
                      </mat-option>
                      <mat-option value="posts">
                        {{ 'Posts' | translate }}
                      </mat-option>
                      <mat-option value="externalURL">
                        {{ 'External URL' | translate }}
                      </mat-option>
                      <mat-option value="account">
                        {{ 'Account Page' | translate }}
                      </mat-option>
                      <mat-option value="signup">
                        {{ 'Signup / Signin' | translate }}
                      </mat-option>
                      <mat-option value="contact">
                        {{ 'Contact Us' | translate }}
                      </mat-option>
                      <mat-option value="about">
                        {{ 'About Us' | translate }}
                      </mat-option>
                      <mat-option value="orders">
                        {{ 'Orders' | translate }}
                      </mat-option>
                      <mat-option value="wishlist">
                        {{ 'Wishlist' | translate }}
                      </mat-option>
                      <mat-option value="referral">
                        {{ 'referral' | translate }}
                      </mat-option>
                      <mat-option value="cart">
                        {{ 'Cart' | translate }}
                      </mat-option>
                      <mat-option value="terms">
                        {{ 'Terms' | translate }}
                      </mat-option>
                      <mat-option *ngFor="let customView of builderService.customViews" value="{{ customView.view_name }}">
                        {{ customView.view_name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </li>
                <li *ngIf="getBlockFields(blockId).data?.menuItems[menuItem.index].link == 'products' && !builderService.standalone">
                  <mat-form-field appearance="outline">
                    <mat-label>{{ 'Product' | translate }}</mat-label>
                    <mat-select (selectionChange)="queryChange('product', blockId, $event, 'multilevelSelect', menuItem.index, 'menuItems')" [(value)]="getBlockFields(blockId).data.menuItems[menuItem.index].product">
                      <mat-option *ngFor="let product of storedProducts" [value]="product.id">
                        {{ product.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </li>
                <li *ngIf="getBlockFields(blockId).data?.menuItems[menuItem.index].link == 'products' && builderService.standalone">
                  <mat-form-field appearance="outline">
                    <mat-label>{{ 'Standalone Product' | translate }}</mat-label>
                    <mat-select (selectionChange)="queryChange('product', blockId, $event, 'multilevelSelect', menuItem.index, 'menuItems')" [(value)]="getBlockFields(blockId).data.menuItems[menuItem.index].product">
                      <mat-option *ngFor="let product of standaloneProductsService.storedStandaloneProducts" [value]="product.Id || product.product_id">
                        {{ product.productName }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </li>
                <!-- <li *ngIf="getBlockFields(blockId).data?.menuItems[menuItem.index].link == 'productsCategories' && !builderService.standalone">
                  <mat-form-field appearance="outline">
                    <mat-label>{{ 'Product Category' | translate }}</mat-label>
                    <mat-select (selectionChange)="queryChange('categories', blockId, $event, 'multilevelSelect', menuItem.index, 'menuItems')" [(value)]="getBlockFields(blockId).data?.menuItems[menuItem.index].categories">
                      <mat-option *ngFor="let productCategory of categoriesService.storedCategories" [value]="productCategory.id">
                        {{ productCategory.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </li>

                <li *ngIf="getBlockFields(blockId).data?.menuItems[menuItem.index].link == 'productsCategories' || (getBlockFields(blockId).data?.menuItems[menuItem.index].link == 'productsSubCategories' && builderService.standalone)">
                  <mat-form-field appearance="outline">
                    <mat-label>{{ 'Product Category' | translate }}</mat-label>
                    <mat-select (selectionChange)="queryChange('categories', blockId, $event, 'multilevelSelect', menuItem.index, 'menuItems'); getCat($event)" [(value)]="getBlockFields(blockId).data?.menuItems[menuItem.index].categories">
                      <mat-option *ngFor="let productCategory of standaloneCategoriesService.storedStandaloneCategories" [value]="productCategory.id">
                        {{ productCategory.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </li>
                <li *ngIf="getBlockFields(blockId).data?.menuItems[menuItem.index].link == 'productsSubCategories' && builderService.standalone && this.standaloneCategoriesService.availableSubs?.length > 0">
                  <mat-form-field appearance="outline">
                    <mat-label>{{ 'Product Sub Category' | translate }}</mat-label>
                    <mat-select (selectionChange)="queryChange('subcategories', blockId, $event, 'multilevelSelect', menuItem.index, 'menuItems')" [(value)]="getBlockFields(blockId).data?.menuItems[menuItem.index].subcategories">
                      <mat-option *ngFor="let subCat of this.standaloneCategoriesService.availableSubs" [value]="subCat.subCategoryId">
                        {{ subCat.subcategory }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </li> -->
                <!-- <li *ngIf="getBlockFields(blockId).data?.menuItems[menuItem.index].link == 'posts'">
                    <mat-label>{{'Post Type' | translate }}</mat-label>
                    <mat-select (selectionChange)="queryChange('post_type', blockId, $event, 'multilevelSelect', menuItem.index, 'menuItems')"
                      value="{{getBlockFields(blockId).data?.menuItems[menuItem.index].post_type}}">
                      <mat-option *ngFor="let postType of postTypes" [value]="postType">
                        {{postType}}
                      </mat-option>
                    </mat-select>
                  </li> -->
                <!-- <li *ngIf="getBlockFields(blockId).data?.menuItems[menuItem.index].link == 'posts'">
                  <mat-form-field appearance="outline">
                    <mat-label>{{ 'Post' | translate }}</mat-label>
                    <mat-select (selectionChange)="queryChange('post', blockId, $event, 'multilevelSelect', menuItem.index, 'menuItems')" [(value)]="getBlockFields(blockId).data?.menuItems[menuItem.index].post">
                      <mat-option *ngFor="let post of storedPosts" [value]="post.ID">
                        {{ post.post_title }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </li> -->
            <!-- in App Browser Options to open -->
            <li *ngIf="getBlockFields(blockId).data?.menuItems[menuItem.index].link == 'externalURL'" class="externalContent">
            <label class="externalOptions">
                <input
                  type="radio"
                  name="browseOption-{{getBlockFields(blockId).data?.menuItems[menuItem.index].index}}"
                  value="browser"
                  [checked]="!getBlockFields(blockId).data.menuItems[menuItem.index].browseOption || getBlockFields(blockId).data?.menuItems[menuItem.index].browseOption == 'browser'"
                  (change)="queryChange('browseOption', blockId, $event, 'multilevelText', menuItem.index, 'menuItems')"
                />  
                {{ 'Browser' | translate}}
              </label>

                <label class="externalOptions">
                  <input
                    type="radio"
                    name="browseOption-{{getBlockFields(blockId).data?.menuItems[menuItem.index].index}}"
                    value="inApp"
                    [checked]="getBlockFields(blockId).data?.menuItems[menuItem.index].browseOption == 'inApp'"
                    (change)="queryChange('browseOption', blockId, $event, 'multilevelText', menuItem.index, 'menuItems')"
                  />
                  {{'In-app Browse' | translate}}
                </label>
              </li>
                <li *ngIf="getBlockFields(blockId).data?.menuItems[menuItem.index].link == 'externalURL'">
                  <mat-form-field appearance="outline">
                    <mat-label>{{ 'External URL' | translate }}</mat-label>
                    <input matInput value="{{ getBlockFields(blockId).data?.menuItems[menuItem.index].externalURL }}" (keyup)="queryChange('externalURL', blockId, $event, 'multilevelText', menuItem.index, 'menuItems')" />
                  </mat-form-field>
                </li>
              </ul>
            </div>
          </li>
        </ul>
        <li>
          <button class="addItem" (click)="addMenuItem(blockId)">{{ 'Add Item' | translate }}</button>
        </li>
      </ul>
    </div>
  </div>

  <!-- Floating Social Shared Preview Template -->
  <ng-template #floatingSocialTpl let-socials="socials">
    <ng-container *ngIf="socials?.enabled && socials?.socials?.length">
      <div class="floatingSocialPreview" [ngClass]="'position-' + (socials?.style?.['position-x'] || 'right')">
        <!-- Single icon: show directly without toggle -->
        <ng-container *ngIf="socials.socials.length === 1">
          <div class="previewSocialIcon mainBtn"
            [style.background-color]="socials.socials[0].platform !== 'custom' ? getPlatformColor(socials.socials[0].platform) : 'transparent'"
            [title]="getPlatformLabel(socials.socials[0].platform)">
            <img *ngIf="socials.socials[0].platform === 'custom' && socials.socials[0].image"
              [src]="socials.socials[0].image" class="customSocialImg" />
            <span *ngIf="socials.socials[0].platform !== 'custom'"
              [innerHTML]="getPlatformIcon(socials.socials[0].platform)"></span>
          </div>
        </ng-container>
        <!-- Multiple icons: stacked list + share toggle button -->
        <ng-container *ngIf="socials.socials.length > 1">
          <div class="previewSocialList">
            <div *ngFor="let social of socials.socials"
              class="previewSocialIcon"
              [style.background-color]="social.platform !== 'custom' ? getPlatformColor(social.platform) : 'transparent'"
              [title]="getPlatformLabel(social.platform)">
              <img *ngIf="social.platform === 'custom' && social.image"
                [src]="social.image" class="customSocialImg" />
              <span *ngIf="social.platform !== 'custom'"
                [innerHTML]="getPlatformIcon(social.platform)"></span>
            </div>
          </div>
          <div class="previewSocialIcon mainBtn shareBtn"
            [style.background-color]="socials.style?.['background-color'] || '#567EDC'">
            <span class="material-icons-outlined">chat_bubble_outline</span>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </ng-template>

  <!-- Style Tab (Website Builder Only) -->
  <div class="styleFields" *ngIf="checkStyle() && builderType === 'website'">
      <div class="sectionHeader">{{ 'Templates' | translate }}</div>
    <ul>
      <!-- Footer Templates Section -->
      <li>
        <div class="footerTemplatesGrid">
          <div
            class="templateCard"
            [class.activeTemplate]="getBlockFields(blockId).data?.footerTemplate === 'template1' || !getBlockFields(blockId).data?.footerTemplate"
            (click)="selectFooterTemplate(blockId, 'template1')">
            <img src="../../../assets/images/footer-templates/classic.png" [alt]="'Template 1 - Classic' | translate" class="templatePreview">
            <p class="templateLabel">{{ 'Classic' | translate }}</p>
          </div>
          <div
            class="templateCard"
            [class.activeTemplate]="getBlockFields(blockId).data?.footerTemplate === 'template2'"
            (click)="selectFooterTemplate(blockId, 'template2')">
            <img src="../../../assets/images/footer-templates/compact.png" [alt]="'Template 2 - Compact' | translate" class="templatePreview">
            <p class="templateLabel">{{ 'Compact' | translate }}</p>
          </div>
          <div
            class="templateCard"
            [class.activeTemplate]="getBlockFields(blockId).data?.footerTemplate === 'template3'"
            (click)="selectFooterTemplate(blockId, 'template3')">
            <img src="../../../assets/images/footer-templates/line.png" [alt]="'Template 4 - Line' | translate" class="templatePreview">
            <p class="templateLabel">{{ 'Line' | translate }}</p>
          </div>
          <div
            class="templateCard"
            [class.activeTemplate]="getBlockFields(blockId).data?.footerTemplate === 'template4'"
            (click)="selectFooterTemplate(blockId, 'template4')">
            <img src="../../../assets/images/footer-templates/wave.png" [alt]="'Template 3 - Wave' | translate" class="templatePreview">
            <p class="templateLabel">{{ 'Wave' | translate }}</p>
          </div>
          <div
            class="templateCard"
            [class.activeTemplate]="getBlockFields(blockId).data?.footerTemplate === 'template5'"
            (click)="selectFooterTemplate(blockId, 'template5')">
            <img src="../../../assets/images/footer-templates/wrap.png" [alt]="'Template 5 - Wrap' | translate" class="templatePreview">
            <p class="templateLabel">{{ 'Wrap' | translate }}</p>
          </div>
          <div
            class="templateCard"
            [class.activeTemplate]="getBlockFields(blockId).data?.footerTemplate === 'template6'"
            (click)="selectFooterTemplate(blockId, 'template6')">
            <img src="../../../assets/images/footer-templates/imageFooter.png" [alt]="'Template 6 - Image Footer' | translate" class="templatePreview">
            <p class="templateLabel">{{ 'Image Footer' | translate }}</p>
          </div>
        </div>
      </li>
    </ul>
  </div>
</section>
